import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import { formatDateTime } from '../../../utils/dateUtils';
import dayjs from 'dayjs';

const ExportFinalPayout = (props) => {
  const { rows,startDate,endDate } = props;
  const exportMapping = [
    {
      header: 'Seller_ID',
      value: (row) => `${row.expert_id}`
    },
    {
      header: 'Seller_Name',
      value: (row) => `${row.expert_name}`
    },
    {
      header: 'Week_Start_Date',
      value: (row) => row.start_date ? `="${row.start_date}"` : ''
    },
    {
      header: 'Week_End_Date',
      value: (row) => row.end_date ? `="${row.end_date}"` : ''
    },
    {
      header: 'Order_Count',
      value: (row) => `${row.total_bookings}`
    },
    {
      header: 'Net_Payable',
      value: (row) => `${row.total_payable_amount}`
    },
    {
      header: 'Payout_Date',
      value: (row) => row.payout_cycle_date ? `="${row.payout_cycle_date}"` : ''
    },
    {
      header: 'Payout_Status',
      value: (row) => `Pending`
    },
    {
      header: 'Penalty',
      value: (row) => ``
    },
    {
      header: 'UTR_or_Ref_No',
      value: (row) => ``
    },
    {
      header: 'Notes',
      value: (row) => ``
    },
    {
      header: 'BANK ACCOUNT NAME',
      value: (row) => `${row.beneficiary_name}`
    },
    {
      header: 'BANK ACCOUNT NUMBER',
      value: (row) => row.account_number ? `="${row.account_number}"` : ''
    },
    {
      header: 'BANK NAME',
      value: (row) => `${row.bank_name}`
    },
    {
      header: 'IFSC CODE',
      value: (row) => `${row.ifsc_code}`
    }
  ];

  const handleExportAllRows = async () => {
    try {

      // Transform data using custom mapping
      const exportData = rows.map(row => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = csvContent.join('\n');
      const blob = new Blob(['﻿', csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const fileName = `Expert_Payout_Report_${dayjs(startDate).format('DD-MM-YYYY')}_to_${dayjs(endDate).format('DD-MM-YYYY')}`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="${fileName}.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
        size='small'
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportFinalPayout;